<template>
    <div class="cpo-section grid" :class="rootClasses">
        <div class="cpo-section--container" :class="containerClasses">
            <div class="grid--row cpo-section--row">
                <div class="grid--col cpo-section--title-col">
                    <div class="cpo-section--title-root" v-if="content.title">
                        <h2 class="u-reset cpo-section--title" v-text="content.title"></h2>
                    </div>
                </div>
                <div class="grid--col cpo-section--content-col">
                    <ul class="u-reset cpo-section--items">
                        <li v-for="(item, itemIdx) in content.items" class="cpo-section--item">
                            <!-- TODO: Remove check `item.content`-->
                            <cmp-cpo-event :plugin="item"
                                    :facet="item.content && item.content.facet"
                                    :color-facet="eventFacet"
                                    :is-global-first="isFirst"
                                    :is-global-last="isLast"
                                    :is-first="itemIdx === 0"
                                    :is-last="itemIdx === content.items.length - 1"
                                    :is-light="isLight"
                                    :is-dark="isDark">
                            </cmp-cpo-event>
                            <!-- <pre v-if="item" v-text="item"></pre> -->
                        </li>
                    </ul>
                </div>
            </div>

            <!-- <pre v-if="content" v-text="content"></pre> -->

        </div>
    </div>
</template>

<script>
    import bemMixin from 'vue/mixins/bem';


    export default {
        mixins: [
            bemMixin('cpo-section'),
        ],
        props: {
            content: Object,
            idx: Number,
            isLast: Boolean,
            isFirst: Boolean,
        },
        computed: {
            isLight() {
                return !this.isFirst && this.idx % 2 === 0;
            },
            isDark() {
                return !this.isFirst && this.idx % 2 === 1;
            },
            eventFacet() {
                if (this.isFirst) {
                    return 'white';
                }

                return 'light';
            },
            rootClasses() {
                return [
                    this.bemFacet,
                    this.bemAdd(this.isFirst ? 'is-first' : ''),
                    this.bemAdd(this.isLast ? 'is-last' : ''),
                    this.bemAdd(this.isLight ? 'is-light' : ''),
                    this.bemAdd(this.isDark ? 'is-dark' : ''),
                ];
            },
            containerClasses() {
                return [
                    this.facet === 'preview' ? '' : 'grid--container',
                ];
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?14649620